import React from 'react';
import PropTypes from 'prop-types';
import TickerChart from './TickerChart';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withComponentId } from './../../../common/ComponentIdContext';
import { REDUCER_NAME, fetchListChart, changeTimeRange } from './../reducer';
import Loading from './../../../common/loading/Loading';
import { customDataChart } from './../../../helpers/Chart';
import { TimeRange } from './../../../common/chart';
import Const from './../Const';
import { Translate } from 'react-redux-i18n';
import SizeTracker from '../../../common/size-tracker/SizeTracker';

const CHART_MIN_WIDTH = 360;

class TickerChartWrap extends React.Component {
  state = {
    keyChart: 1,
  };

  componentDidMount() {
    const {
      fetchListChart,
      componentId,
      currentSearch,
      timeRange,
    } = this.props;

    fetchListChart(currentSearch, timeRange, componentId);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.data !== this.props.data) {
      this.setState({ keyChart: this.state.keyChart + 1 });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      timeRange,
      fetchListChart,
      currentSearch,
      componentId,
    } = this.props;
    if (timeRange !== prevProps.timeRange) {
      fetchListChart(currentSearch, timeRange, componentId);
    }
  }

  changeTimeRange = timeRange => {
    const { changeTimeRange, componentId } = this.props;

    changeTimeRange(timeRange, componentId);
  };

  getFieldAreaChart = () => {
    const { timeRange } = this.props;

    return timeRange === Const.timeRange['1D'] ? 'matchPrice' : 'closePrice';
  };

  renderTimeRange = () => {
    const { timeRange } = this.props;

    return (
      <TimeRange
        listTimeRange={Const.timeRange}
        timeRange={timeRange}
        changeTimeRange={this.changeTimeRange}
      />
    );
  };

  render() {
    const { keyChart } = this.state;
    const { data, timeRange, isLoading } = this.props;
    const customData = customDataChart(data, timeRange, 'ticker');

    return (
      <SizeTracker className={'d-flex flex-fill'}>
        {(width, height) => {
          return (
            <div className="position-relative" style={{ height }}>
              {isLoading && <Loading />}
              {this.renderTimeRange()}
              <div className={isLoading ? 'bg-blur' : ''}>
                {customData && customData.length > 1 ? (
                  <TickerChart
                    key={`${width}_${keyChart}`}
                    isLoading={isLoading}
                    data={customData}
                    width={Math.max(width, CHART_MIN_WIDTH)}
                    ratio={window.devicePixelRatio}
                    timeRange={timeRange}
                    fieldAreaChart={this.getFieldAreaChart()}
                    refPriceKey={'referencePrice'}
                  />
                ) : (
                  !isLoading && (
                    <div className="ml-5">
                      <Translate value={'common.NO_DATA'} />
                    </div>
                  )
                )}
              </div>
            </div>
          );
        }}
      </SizeTracker>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    data: state[REDUCER_NAME].listMultiComponent[componentId].dataChartIndex,
    timeRange: state[REDUCER_NAME].listMultiComponent[componentId].timeRange,
    component: state[REDUCER_NAME].listMultiComponent[componentId].component,
    isLoading: state[REDUCER_NAME].listMultiComponent[componentId].isLoading,
    currentSearch:
      state[REDUCER_NAME].listMultiComponent[componentId].currentSearch,
  };
};

const mapDispatchToProps = {
  fetchListChart,
  changeTimeRange,
};

TickerChartWrap.propTypes = {
  data: PropTypes.array.isRequired,
  currentSearch: PropTypes.object,
  timeRange: PropTypes.string,
  isLoading: PropTypes.bool,
};

TickerChartWrap.defaultProps = {
  data: [],
  currentSearch: {},
  timeRange: '',
  isLoading: false,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(TickerChartWrap);
